<template>
  <div class="flex flex-vertical-center">
    <p class="property_address">
      {{ recordTitle }}
    </p>
  </div>
</template>

<script>

import utils from "../../../services/utils";

export default {
  name: "LeadHeaderMobile",
  computed: {
    record() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord : {
        property: {
          line_1: ''
        },
      };
    },
    recordTitle() {
      if(!this.record) return '';

      let title = this.record.property.line_1 ? this.record.property.line_1 : 'Unknown Address';

      return utils.truncateString(title, 50);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.property_address {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.2;
}
</style>
